const projectData = [
    {
        id: 1,
        projectName: "Technove Global Software",
        demo: "https://technove.co.in/",
        imgsrc: "Technove Global.png"
    },
    {
        id: 2,
        projectName: "Bonehornmart",
        demo: "https://bonehornmart.com/",
        imgsrc: "Bonehornmart.png"
    },
    {
        id: 3,
        projectName: "IPv4 Subnetting App",
        demo: "https://ipv4-subnetting-practice.netlify.app/",
        imgsrc: "IPv4 Subnetting.png"
    },
    {
        id: 4,
        projectName: "Fostertechs",
        demo: "https://fostertechs.com/",
        imgsrc: "Fostertechs.png"
    },
    {
        id: 5,
        projectName: "Unlimited PDF Converter ",
        demo: "https://unlimitedpdfconverter.netlify.app/word-to-pdf",
        imgsrc: "pdf-converter.png"
    },
    {
        id: 6,
        projectName: "shopCasa E-Commerce Vite+React",
        demo: "https://shopcasa.netlify.app/",
        imgsrc: "shopCasa.png"
    },
    {
        id: 7,
        projectName: "Hunar E-Commerce Nodejs",
        demo: "https://hunar.onrender.com",
        imgsrc: "Hunar.jpg"
    },
    {
        id: 8,
        projectName: "Quotes App MERN",
        demo: "https://quote-app-from-react.netlify.app/",
        imgsrc: "Quotes App.png"
    },
    {
        id: 9,
        projectName: "Weather App",
        demo: "https://weather-application-with-change-image.netlify.app/",
        imgsrc: "Weather.png"
    },
    {
        id: 10,
        projectName: "Chat App with Socket.IO",
        demo: "https://chat-app-agu9.onrender.com/",
        imgsrc: "Chat App.png"
    },
    {
        id: 11,
        projectName: "BMW India Clone",
        demo: "https://bmw-india-clone.netlify.app/",
        imgsrc: "BMW.png"
    },
    {
        id: 12,
        projectName: "Color Generator with React",
        demo: "https://color-generator-from-react.netlify.app/",
        imgsrc: "Color Generator.png"
    }
]

export default projectData;